import React from 'react';

function WidgetGetinTouch({ heading, text, icon, type }) {

    const generateLink = (type, text) => {
        switch (type) {
            case 1:
                return "tel:" + text;
            case 2:
                return "mailto:" + text;
            case 3:
                return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(text);
            default:
                return "";
        }
    };
    

    return (
        <>
            <div className="single-contact-info">
                <div className="icon">{icon}</div>
                <div className="contact-info">
                    <span>{heading}</span>
                    <a className='footer-text-hover' target='_blank' href={generateLink(type,text)}>{text}</a>
                </div>
            </div>
        </>
    );
}

export default WidgetGetinTouch;
